export default __webpack_public_path__ + "static/media/mahmood.6975aa54.jpg";